import { memo } from "react"

const IconAccountDetails = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
      <path
        d="M2.625 5.625V3.75C2.625 3.05937 3.18437 2.5 3.875 2.5H12.625C13.3156 2.5 13.875 3.05937 13.875 3.75V11.25C13.875 11.9406 13.3156 12.5 12.625 12.5H8.875"
        stroke="#002C98"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.375 12.4998L6.21813 12.106C6.13875 11.9066 6.01562 11.7273 5.85812 11.5816V11.5816C5.59125 11.3341 5.24063 11.1973 4.8775 11.1973H3.4975C3.13375 11.1973 2.78375 11.3348 2.51688 11.5816V11.5816C2.35938 11.7273 2.23625 11.9066 2.15687 12.106L2 12.4998"
        stroke="#002C98"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.96078 7.82063C5.38766 8.2475 5.38766 8.94 4.96078 9.3675C4.53391 9.79437 3.84141 9.79437 3.41391 9.3675C2.98703 8.94062 2.98703 8.24813 3.41391 7.82063C3.84141 7.39312 4.53391 7.39312 4.96078 7.82063"
        stroke="#002C98"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.625 9.375V5.625"
        stroke="#002C98"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5 9.37578V7.30078"
        stroke="#002C98"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.375 9.375V5.96875"
        stroke="#002C98"
        stroke-width="0.9375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconAccountDetails)
